module.exports = __webpack_public_path__ + "img/order.7926f246.png";